export type LexicalNode = Record<any, any>

export function findFirstNode(node: LexicalNode, where: (node: LexicalNode) => boolean): LexicalNode {
    if (where(node)) {
        return node
    }

    if (!node.children) {
        return null
    }

    for (const child of node.children) {
        const matched = findFirstNode(child, where)
        if (matched !== null) {
            return matched
        }
    }

    return null
}

export function findNodes(node: LexicalNode, where: (node: LexicalNode) => boolean): LexicalNode {
    let nodes = []

    if (where(node)) {
        nodes.push(node)
    }

    if (!node.children) {
        return nodes
    }

    nodes = nodes.concat(node.children.flatMap((child: LexicalNode) => findNodes(child, where)))

    return nodes
}
